/*
 * Customer note Messages
 *
 * This contains all the text for the Customer note container.
 */

import { defineMessages } from 'react-intl';

export const scope = 'app.components.Form.PriceListMaster';

export default defineMessages({
  startDate: {
    id: `${scope}.startDate`,
    defaultMessage: 'Valid from',
  },
  endDate: {
    id: `${scope}.endDate`,
    defaultMessage: 'Valid to',
  },
  description: {
    id: `${scope}.description`,
    defaultMessage: 'Description',
  },
  price_list_saved: {
    id: `${scope}.price_list_saved`,
    defaultMessage: 'Price list saved succesfully!',
  },
  price_list_deleted: {
    id: `${scope}.price_list_deleted`,
    defaultMessage: 'Price list deleted succesfully!',
  },
  code: {
    id: `${scope}.code`,
    defaultMessage: 'Code',
  },
  start_lt_end_date: {
    id: `${scope}.start_lt_end_date`,
    defaultMessage: 'The start date should be before the end date.',
  },
});
